module.exports = __webpack_public_path__ + "media/images/ecommerce/product_img_02-705a2fc1abd9fc814eb3d79b6fa22b86.jpg";